import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Menu from '../menu/Menu';
import Tile from '../common/Tile';
import '../common/rtCommon.css';
import '../common/Tile.css';
import './StaffManagement.css';

const tiles = [
  {
    icon: '👤',
    title: 'Add Staff',
    description: 'Create new staff accounts and manage permissions',
    url: 'add',
    access_roles: ['RT_Admin'] // Default to admin
  },
  {
    icon: '👥',
    title: 'View Staffs',
    description: 'View all staff members and their details',
    url: 'view',
    access_roles: ['RT_Admin'] // Default to admin
  },
  {
    icon: '🏷️',
    title: 'Manage Staff Types',
    description: 'Create and manage different staff type categories',
    url: 'types',
    access_roles: ['RT_Admin'] // Default to admin
  },
  {
    icon: '🔗',
    title: 'Staff - Complaint Type',
    description: 'Map complaint types to staff type categories',
    url: 'complaint-mapping',
    access_roles: ['RT_Admin'] // Default to admin
  }
];

const StaffManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="rt-layout">
      <Menu className="rt-menu" activePath={location.pathname} />
      <div className="rt-main-content">
        <div className="rt-title-row">
          <h2 className="rt-title">Manage Staffs</h2>
        </div>
        <div className="rt-main-section">
          <div className="rt-tiles-grid">
            {tiles.map((tile, idx) => (
              <Tile
                key={idx}
                icon={tile.icon}
                title={tile.title}
                description={tile.description}
                disabled={tile.disabled}
                access_roles={tile.access_roles}
                onClick={() => tile.url && navigate(tile.url)}
                tabIndex={0}
                role="button"
                onKeyPress={e => { if (e.key === 'Enter' && tile.url) navigate(tile.url); }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffManagement;